import { faUserPlus, faUserEdit } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { AddClient, LangUpdateClient } from '../../constant/languange'

function ClientImportChooseComponent({ setControl }) {
  return (
    <div className='d-flex w-100'>
      <button className='m-1 btn btn-light d-flex flex-column align-items-center py-3' style={{ flex: 1 }} onClick={() => setControl(control => ({ ...control, showModal: 'import-create' }))}>
        <FontAwesomeIcon icon={faUserPlus} size='3x' />
        <span className='mt-2'>{AddClient}</span>
      </button>
      <button className='m-1 btn btn-light d-flex flex-column align-items-center py-3' style={{ flex: 1 }} onClick={() => setControl(control => ({ ...control, showModal: 'import-update' }))}>
        <FontAwesomeIcon icon={faUserEdit} size='3x' />
        <span className='mt-2'>{LangUpdateClient}</span>
      </button>
    </div>
  )
}

export default ClientImportChooseComponent
